<template>
  <div style="margin-top: 20px">
    <div class="container-fluid">
      <div class="row-fluid">
        <!--最新活动-->
        <div class="span12 text-left">
          <div class="jumbotron bg">
            <div class="container">
              <div class="row" style="height: 100px">
                <!-- <div class="col-2 middle">
                <img src="../../assets/logo.png" width="50" height="50" />
              </div> -->
                <!-- <div class="col-6">
                <div>
                  <h4>张帅</h4>
                </div>
                <div>523 积分</div>
              </div>
              <div class="col-4 text-right middle">
                <span class="label label-default">成为志愿者</span>
              </div> -->
              </div>
            </div>
          </div>
          <div class="text-left">
            <!-- <button class="switch" v-for="(item,index) in list" :key="index" :class="{active: current == index}"
            @click='tabToggle(index)'>{{item}}</button> -->
            <ul class="nav nav-tabs">
              <li
                role="presentation"
                v-for="(item, index) in List"
                :key="index"
                :class="{ active: current == index }"
                @click="changeActive(item, index)"
              >
                <a href="javascript:;">{{ item.text }}</a>
              </li>
            </ul>
            <!-- <button class="switch">社会组织</button>
      <button class="switch">个人</button> -->
          </div>
          <div v-if="current == 0">
            <div
              class="jumbotron_c t_20"
              v-for="(item, index) in list1"
              :key="index"
              @click="
                $router.push({
                  name: 'server_user_shows',
                  query: { id: item.id },
                })
              "
            >
              <div class="row">
                <div class="col-3" style="padding-right: 0px">
                  <div style="padding: 10px 0px 10px 10px">
                    <img
                      style="height: 70px; max-width: 70px"
                      :src="item.avatar_url"
                      v-if="item.avatar_url"
                      title="暂无图片"
                    />
                    <div class="imgsss" v-else>
                      暂&nbsp;&nbsp;无<br />图&nbsp;&nbsp;片
                    </div>
                  </div>
                </div>
                <div class="col-9">
                  <h5 class="h5_t_5">
                    <span
                      class="label label-primary label_50"
                      style="padding-top: 4px"
                      >群团组织</span
                    >
                    &nbsp;{{ item.describe }}
                  </h5>
                  <footer
                    class="blockquote-footer"
                    style="
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    "
                  >
                    {{ item.title }}
                  </footer>
                  <h5
                    class="text-right"
                    style="margin-bottom: 0px; padding-top: 3px"
                  >
                    <span class="label label-primary-j">详细信息</span>
                  </h5>
                </div>
              </div>
            </div>
            <button
              v-if="moreShowBoolen"
              @click="moreShow1"
              class="btn_page btn1"
              style="
                display: block;
                margin: 25px auto 0;
                outline: none;
                color: #666;
                background-color: #eee;
                border-radius: 25px;
                height: 30px;
                width: 60%;
              "
            >
              更多选项
            </button>
            <div v-else style="text-align: center; margin-top: 15px">
              已无更多
            </div>
            <!-- <div class="jumbotron_c t_20">
            <div class="row">
              <div class="col-3" style="padding-right:0px;">
                <div style="padding:10px 0px 10px 10px;">
                  <img style="width: 100%; height: 70px;" src="https://img.hsnms.com/20210807/1628335448.jpg" />
                </div>
              </div>
              <div class="col-9">
                <h5 class="h5_t_5"><span class="label label-primary label_50">主要标签</span> 是服务队伍的聚集地</h5>
                <footer class="blockquote-footer">From WWF's website</footer>
                <h5 class="text-right" style="margin-bottom:0px; padding-top: 3px;"><span
                    class="label label-primary-j">详细信息</span></h5>
              </div>
            </div>
          </div> -->
          </div>
          <div v-if="current == 1">
            <div
              class="jumbotron_c t_20"
              v-for="(item, index) in list2"
              :key="index"
              @click="
                $router.push({
                  name: 'server_user_shows',
                  query: { id: item.id },
                })
              "
            >
              <div class="row">
                <div class="col-3" style="padding-right: 0px">
                  <div style="padding: 10px 0px 10px 10px">
                    <img
                      style="height: 70px; max-width: 70px"
                      :src="item.avatar_url"
                      v-if="item.avatar_url"
                      title="暂无图片"
                    />
                    <div class="imgsss" v-else>
                      暂&nbsp;&nbsp;无<br />图&nbsp;&nbsp;片
                    </div>
                  </div>
                </div>
                <div class="col-9">
                  <h5 class="h5_t_5">
                    <span
                      class="label label-primary label_50"
                      style="padding-top: 4px"
                      >社会组织</span
                    >
                    &nbsp;{{ item.describe }}
                  </h5>
                  <footer
                    class="blockquote-footer"
                    style="
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    "
                  >
                    {{ item.title }}
                  </footer>
                  <h5
                    class="text-right"
                    style="margin-bottom: 0px; padding-top: 3px"
                  >
                    <span class="label label-primary-j">详细信息</span>
                  </h5>
                </div>
              </div>
            </div>
            <button
              v-if="moreShowBoolen2"
              @click="moreShow2"
              class="btn_page btn1"
              style="
                display: block;
                margin: 15px auto 0;
                outline: none;
                color: #666;
                background-color: #eee;
                border-radius: 25px;
                height: 30px;
                width: 60%;
              "
            >
              更多选项
            </button>
            <div v-else style="text-align: center; margin-top: 15px">
              已无更多
            </div>
            <!-- <div class="jumbotron_c t_20">
            <div class="row">
              <div class="col-3" style="padding-right:0px;">
                <div style="padding:10px 0px 10px 10px;">
                  <img style="width: 100%; height: 70px;" src="https://img.hsnms.com/20210807/1628335448.jpg" />
                </div>
              </div>
              <div class="col-9">
                <h5 class="h5_t_5"><span class="label label-primary label_50">主要标签</span> 是服务队伍的聚集地</h5>
                <footer class="blockquote-footer">From WWF's website</footer>
                <h5 class="text-right" style="margin-bottom:0px; padding-top: 3px;"><span
                    class="label label-primary-j">详细信息</span></h5>
              </div>
            </div>
          </div> -->
          </div>
          <div v-if="current == 2">
            <div
              class="jumbotron_c t_20"
              v-for="(item, index) in list3"
              :key="index"
              @click="
                $router.push({
                  name: 'server_user_shows',
                  query: { id: item.id },
                })
              "
            >
              <div class="row">
                <div class="col-3" style="padding-right: 0px">
                  <div style="padding: 10px 0px 10px 10px">
                    <img
                      style="height: 70px; max-width: 70px"
                      :src="item.avatar_url"
                      v-if="item.avatar_url"
                      title="暂无图片"
                    />
                    <div class="imgsss" v-else>
                      暂&nbsp;&nbsp;无<br />图&nbsp;&nbsp;片
                    </div>
                  </div>
                </div>
                <div class="col-9">
                  <h5 class="h5_t_5">
                    <span
                      class="label label-primary label_50"
                      style="padding-top: 4px"
                      >个人</span
                    >
                    &nbsp;{{ item.describe }}
                  </h5>
                  <footer
                    class="blockquote-footer"
                    style="
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    "
                  >
                    {{ item.title }}
                  </footer>
                  <h5
                    class="text-right"
                    style="margin-bottom: 0px; padding-top: 3px"
                  >
                    <span class="label label-primary-j">详细信息</span>
                  </h5>
                </div>
              </div>
            </div>
            <button
              v-if="moreShowBoolen3"
              @click="moreShow3"
              class="btn_page btn1"
              style="
                display: block;
                margin: 15px auto 0;
                outline: none;
                color: #666;
                background-color: #eee;
                border-radius: 25px;
                height: 30px;
                width: 60%;
              "
            >
              更多选项
            </button>
            <div v-else style="text-align: center; margin-top: 15px">
              已无更多
            </div>
            <!-- <div class="jumbotron_c t_20">
            <div class="row">
              <div class="col-3" style="padding-right:0px;">
                <div style="padding:10px 0px 10px 10px;">
                  <img style="width: 100%; height: 70px;" src="https://img.hsnms.com/20210807/1628335448.jpg" />
                </div>
              </div>
              <div class="col-9">
                <h5 class="h5_t_5"><span class="label label-primary label_50">主要标签</span> 是服务队伍的聚集地</h5>
                <footer class="blockquote-footer">From WWF's website</footer>
                <h5 class="text-right" style="margin-bottom:0px; padding-top: 3px;"><span
                    class="label label-primary-j">详细信息</span></h5>
              </div>
            </div>
          </div> -->
          </div>
          <div id="d_p" style="height: 80px"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //isLoading: true,
      List: [
        {
          text: "群团组织",
          isActive: true,
        },
        {
          text: "社会组织",
          isActive: false,
        },
        {
          text: "个人",
          isActive: false,
        },
      ],
      current: 0,
      list1: [],
      list2: [],
      list3: [],
      nowPage_t: 1,
      nowPage1_t: 1,
      nowPage2_t: 1,

      moreShowBoolen: false,
      moreShowBoolen2: false,
      moreShowBoolen3: false,
      nowPage: 1,
      nowPage3: 1,
      nowPage2: 1,
      openid: "",
    };
  },
  methods: {
    changeActive: function (data, id) {
      // this.navList.forEach((obj) => (obj.isActive = false))
      // console.log(id);
      this.current = id;
      data.isActive = !data.isActive;
    },
    moreShow3() {
      // 点击查询更多

      this.$api
        .getAPI(
          "mutual/attribute/?appid=202108&type_id=4001&size=10&key_id=3&state=1",
          {
            page: this.nowPage3,
          }
        )
        .then((res) => {
          console.log(res);
          var db = res.data.data.data[0];
          for (let i = 0; i < db.models.length; i++) {
            this.list3.push(db.models[i]);
          }
          this.nowPage3_t = db.page.count;
          this.moreShowBoolen3 = true;
          if (this.nowPage3_t < this.nowPage3 * 10) {
            this.moreShowBoolen3 = false;
          }
          //console.log(res.data)
          //console.log("res.data")
          this.nowPage3++;
        });

      // this.nowPage++
      // this.$axios.get('app/mutual/attribute/?appid=202108&type_id=4001&state=1&key_id=1&size=10&page=' + this
      //   .nowPage).then(res => {
      //   if (res.data.data.data[0].models.length == 10) {
      //     this.moreShowBoolen = true
      //   } else {
      //     this.moreShowBoolen = false
      //   }
      //   for (let i = 0; i < res.data.data.data[0].models.length; i++) {
      //     this.list1.push(res.data.data.data[0].models[i])
      //   }
      // })
    },
    moreShow2() {
      // 点击查询更多
      this.$api
        .getAPI(
          "mutual/attribute/?appid=202108&type_id=4001&size=10&key_id=2&state=1",
          {
            page: this.nowPage2,
          }
        )
        .then((res) => {
          this.moreShow3();
          var db = res.data.data.data[0];
          for (let i = 0; i < db.models.length; i++) {
            this.list2.push(db.models[i]);
          }
          this.nowPage2_t = db.page.count;
          this.moreShowBoolen2 = true;
          if (this.nowPage2_t < this.nowPage2 * 10) {
            this.moreShowBoolen2 = false;
          }
          //console.log(res.data)
          //console.log("res.data")
          this.nowPage2++;
        });

      // this.nowPage1++
      // this.$axios.get('app/mutual/attribute/?appid=202108&type_id=4001&state=1&key_id=2&size=10&page=' + this
      //   .nowPage1).then(res => {
      //   if (res.data.data.data[0].models.length === 10) {
      //     this.moreShowBoolen2 = true
      //   } else {
      //     this.moreShowBoolen2 = false
      //   }
      //   for (let i = 0; i < res.data.data.data[0].models.length; i++) {
      //     this.list2.push(res.data.data.data[0].models[i])
      //   }
      // })
    },
    moreShow1() {
      // 点击查询更多
      //if(pageid)
      this.$api
        .getAPI(
          "mutual/attribute/?appid=202108&type_id=4001&size=10&key_id=1&state=1",
          {
            page: this.nowPage,
          }
        )
        .then((res) => {
          this.moreShow2();

          var db = res.data.data.data[0];
          for (let i = 0; i < db.models.length; i++) {
            this.list1.push(db.models[i]);
          }
          this.nowPage_t = db.page.count;
          this.moreShowBoolen = true;
          if (this.nowPage_t < this.nowPage * 10) {
            this.moreShowBoolen = false;
          }
          this.nowPage++;
        });

      //   this.nowPage2++
      //   this.$axios.get('app/mutual/attribute/?appid=202108&state=1&type_id=4001&key_id=3&size=10&page=' + this
      //     .nowPage2).then(res => {
      //     if (res.data.data.data[0].models.length === 10) {
      //       this.moreShowBoolen3 = true
      //     } else {
      //       this.moreShowBoolen3 = false
      //     }
      //     for (let i = 0; i < res.data.data.data[0].models.length; i++) {
      //       this.list3.push(res.data.data.data[0].models[i])
      //     }
      //   })
      // }
    },
  },
  mounted() {
    this.moreShow1();
    // this.$axios.get("app/mutual/attribute/?appid=202108&type_id=4001&page=1&size=10&key_id=1&state=1").then(
    //   res => {
    //     // console.log(res.data.data[0].models);
    //     if (res.data.data.data[0].models.length === 10) {
    //       this.list1 = res.data.data.data[0].models
    //       this.moreShowBoolen = true
    //     } else {
    //       this.list1 = res.data.data.data[0].models.slice(0, 10)
    //       this.moreShowBoolen = false
    //     }

    //   })
    // this.$axios.get("app/mutual/attribute/?appid=202108&type_id=4001&page=1&size=10&key_id=2&state=1").then(
    //   res => {
    //     // console.log(res.data.data[0].models);
    //     if (res.data.data.data[0].models.length === 10) {
    //       this.list2 = res.data.data.data[0].models
    //       this.moreShowBoolen2 = true

    //     } else {
    //       this.list2 = res.data.data.data[0].models.slice(0, 10)
    //       this.moreShowBoolen2 = false
    //     }
    //   })
    // this.$axios.get("app/mutual/attribute/?appid=202108&type_id=4001&page=1&size=10&key_id=3&state=1").then(
    //   res => {
    //     console.log(res.data.data.data[0].models);
    //     if (res.data.data.data[0].models.length === 10) {
    //       this.list3 = res.data.data.data[0].models
    //       this.moreShowBoolen3 = true

    //     } else {
    //       this.list3 = res.data.data.data[0].models.slice(0, 10)
    //       this.moreShowBoolen3 = false
    //     }
    //   })
    // this.isLoading = false
    // console.log(this.list1);
    // console.log(this.list2);
    // console.log(this.list3);
  },
};
</script>
<style>
/*
  .nav-tabs
  >
  li
  >
  a:hover
  {
  background:
  none;
  border:
  none;
  }
  */
.btn1 {
  border: none;
  outline: 0;
  background: none;
}
/*
  .active
  {
  font-size:
  16px
   !important;
  color:
  #1890ff
   !important;
  font-weight:
  600;
  }
  */
.top-fluid {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.switch {
  outline: none !important;
  margin-left: -6px;
  margin-right: 15px;
  background: none;
  color: #7b7b7b;
  border: none;
  font-size: 14px;
  text-align: left !important;
}
.jumbotron {
  padding: 2rem 2rem;
  margin-bottom: 2rem;
}
.label_50 {
  border-radius: 50px/50px;
}
.page-header {
  margin: 25px 0 0px;
}
.h5_t_5 {
  margin-top: 15px;
}
.b_t_5 {
  padding-top: 6px;
}
.border_ {
  background: #002752;
}
.bg {
  background: url(https://img.hsnms.com/20210924/1632451543.jpg) no-repeat
    center;
  background-size: 100%;
  /*
  box-shadow:
  1px
  1px
  1px
  1px
  rgba(0,
  0,
  0,
  0.4);
  */
}
.carousel-inner {
  border-bottom: 1px solid #000;
}

.carousel-indicators {
  bottom: -40px;
}
.carousel-indicators li {
  background-color: #000000;
}
.carousel-item-img {
  border-top-left-radius: 0.8em;
  border-top-right-radius: 0.8em;
  background-color: transparent;
  box-shadow: 0px 0px 8px 3px #fff;
}
.border {
  display: inline-block;
  width: 70px;
  height: 70px;
  margin: 6px;
}
.jumbotron_a {
  color: #fff;
  background: #01b2c2;
}
.jumbotron_b {
  color: #fff;
  background: #3480fa;
}
.jumbotron_c {
  background: #f3f4f8;
}
.carousel-indicators li {
  width: 8px;
  height: 8px;
  background-color: #00cdc6;
}
.carousel-indicators .active {
  background-color: #00a4b7;
  width: 30px;
  height: 8px;
}
.label-primary {
  color: #3480fa;
  background-color: #ffd986;
}
.label-primary-j {
  color: #fff;
  background-color: #00a4b7;
  border-radius: 15px 0px 0px 0px;
}
.nav a {
  color: #01b2c2;
}
.imgsss {
  text-align: center;
  width: 100%;
  height: 70px;
  font-size: 16px;
  line-height: 35px;
  border: 1px solid #c0c0c0;
}
</style>



// WEBPACK FOOTER //
// src/components/views/server_user_list.vue